import { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

import useGetCampaignList from './api/useGetCampaignList'
import { CheckInEventItem } from './useCheckInEventForm'

export const CheckInEventRelayAtom = atom<CheckInEventItem>({
  key: 'CheckInEventRelayAtom',
  default: {
    campaignId: '',
  },
})

const useCheckInEventRelayForm = () => {
  const [relay, setRelay] = useRecoilState(CheckInEventRelayAtom)
  const { campaigns } = useGetCampaignList()

  // first setup for search params
  useEffect(() => {
    if (campaigns?.length === 0) return
    const latestCampaingn = campaigns?.reduce((prev, current) => (prev.startDate > current.startDate ? prev : current))
    setRelay({
      campaignId: latestCampaingn?.campaignId.toString() ?? '',
      fromDate: latestCampaingn?.startDate.split(' ')[0],
      toDate: latestCampaingn?.endDate.split(' ')[0],
    })
  }, [campaigns, setRelay])

  return { relay, setRelay }
}

export default useCheckInEventRelayForm
